const IOS_DEVICE_REGEXP = /iPad|iPhone|iPod|Macintosh/;

export const isIOS = () => {
  if (!process.client) return;

  return IOS_DEVICE_REGEXP.test(navigator.userAgent) && !window.MSStream && 'ontouchend' in document;
};

export const getDeviceWidth = () => {
  if (typeof window === 'undefined') return;

  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

export const isMobile = () => getDeviceWidth() < 768;
